/**
 * 모바일 주소창 등장/숨김으로 인한 resize 이벤트를 무시하고
 * 실제 viewport 변경(회전, 폭 변경, 큰 높이 변화)만 감지하는 함수
 *
 * @param {Function} callback - 실제 resize 시 실행할 함수
 * @param {Object} [options]
 * @param {number} [options.threshold=150] - 높이 변화 임계값(px)
 * @param {number} [options.debounce=200] - 디바운스 시간(ms)
 */
function detectRealResize(callback, options = {}) {
  const threshold = options.threshold ?? 150;
  const debounce = options.debounce ?? 200;

  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  let prevWidth = window.innerWidth;
  let prevHeight = window.innerHeight;
  let resizeTimer = null;

  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);

    resizeTimer = setTimeout(() => {
      const currWidth = window.innerWidth;
      const currHeight = window.innerHeight;
      const diffHeight = Math.abs(currHeight - prevHeight);

      // 실제 resize 감지 로직
      const isRealResize =
        currWidth !== prevWidth || (isMobile && diffHeight > threshold) || (!isMobile && diffHeight > 0);

      if (isRealResize) {
        callback?.({ width: currWidth, height: currHeight });
      }

      prevWidth = currWidth;
      prevHeight = currHeight;
    }, debounce);
  });
}
